module.exports = __webpack_public_path__ + "img/diamond.24fdcc77.png";